import MachineLearning from './index.vue'

export default [
  {
    path: '/disease-risk-prediction',
    alias: '/machine-learning',
    name: 'DiseaseRiskPrediction',
    component: MachineLearning
  }
]
